import fetch from "@/common/utils/serFetch";
import fetchPub from '@public/http/request'
import { APICUS } from "@public/utils/const";
import { GATEWAYSER, GATEWAY } from '@/common/config/index'

const moduleList = {
  sysUser: `${APICUS}/sysUser`, // 系统用户
  sysArea: `${APICUS}/sysArea`, // 基础信息
  podTracking: `${APICUS}/podTracking`, // 物流跟踪 图片
  thirdService: `${APICUS}/thirdService`, // 物流轨迹
  networkAbnormalInformation: `${APICUS}/networkAbnormalInformation`, // 异常网点
  orderInfo: `${APICUS}/integration`, // 运单信息
  workOrder: `${APICUS}/workOrder`, // 工单
  workOrderInfo: `${APICUS}/workOrderInfo`, // 工单信息
  claimWorkOrderInfo: `${APICUS}/claimWorkOrderInfo`, // 理赔信息
  problemPiece: `${APICUS}/problemPiece`, // 问题件
  problemServiceRecord: `${APICUS}/problemServiceRecord`, // 问题件记录
  arbitration: `${APICUS}/arbitration`, // 仲裁信息
  exportTask: `${APICUS}/exportTask`, // 下载中心异步导出
  problemExpressWo: `${APICUS}/problemExpressWo`, // 质量工单
  messageTemplate: `${APICUS}/smsTemplate`, // 短信模板管理
  comboBox: `${APICUS}/comboBox`, // 分配列表
  bS: `${APICUS}/bs`, // 百世接口
  postal: `${APICUS}/postalCombineInfo`, // 邮政工单
  taskExport: `${APICUS}/exportTask`,
  ylwebsqsserviceonline: `${GATEWAYSER.SQSIM}`
}

// 地址选址
export const reqAddressList = (code) => {
  return fetch.get(
    `${moduleList.sysArea}/select?size=9999&parentId=` + code
  );
};
// 地址选址
export const sysArea = (params) => {
  return fetch.get(`${moduleList.sysArea}/select?size=9999`, {
    params,
  });
};
// 工单管理 => 分配管理
export const reqUserList = (str) => {
  return fetch.get(`${moduleList.sysUser}/page?${str}isEnable=1`);
};

// 工单管理 => 分配列表
export const distributionList = (str, url) => {
  return fetch.get(
    `${moduleList.comboBox}/networkInfo/excludeForbidden?${str}isEnable=1`
  );
};
// 工单详情
export const detailView = {
    // 反查地址
    getAddressDetail(params) {
      return fetch.get(`${APICUS}/cainiaoPwo/getErrorPackageCiq?waybillCode=${params}`)
    },
  // 详情工单处理记录列表
  reqProcessRecords(params, type) {
    const urlObj = {
      // 普通工单
      // "01": `${moduleList.workOrderInfo}/getDistributeProcessRecords`, // 分配
      // "02": `${moduleList.workOrderInfo}/getInputProcessRecords`, // 录入
      // "03": `${moduleList.workOrderInfo}/getHandleProcessRecords`, // 待处理
      // "04": `${moduleList.workOrderInfo}/getHandleProcessRecords`, // 处理中
      // "05": `${moduleList.workOrderInfo}/getHandleProcessRecords`, // 已处理
      "06": `${moduleList.workOrderInfo}/getServiceProcessRecords`, // 服务商
      // 理赔工单
      // "1": `${moduleList.claimWorkOrderInfo}/getDistributeProcessRecords`, // 分配
      // "2": `${moduleList.claimWorkOrderInfo}/getInputProcessRecords`, // 录入
      // "3": `${moduleList.claimWorkOrderInfo}/getHandleProcessRecords`, // 待处理
      // "4": `${moduleList.claimWorkOrderInfo}/getHeadquartersProcessRecords`, // 总部
      // "5": `${moduleList.claimWorkOrderInfo}/getHeadquartersProcessRecords`, // 总部
      // "6": `${moduleList.claimWorkOrderInfo}/getHeadquartersProcessRecords`, // 总部
      // "7": `${moduleList.claimWorkOrderInfo}/getHeadquartersProcessRecords`, // 总部
      // "8": `${moduleList.claimWorkOrderInfo}/getHeadquartersProcessRecords`, // 总部
      // "9": `${moduleList.claimWorkOrderInfo}/getHandleProcessRecords`, // 处理中
      // "10": `${moduleList.claimWorkOrderInfo}/getHandleProcessRecords`, // 已处理
      "11": `${moduleList.claimWorkOrderInfo}/getServiceProcessRecords`, // 服务商
    };
    console.log("type::", type);
    return fetch.get(`${urlObj[type]}`, { params });
  },
  // 详情工单信息 明文
  reqOrderInfoPlaintext(params) {
    return fetch.get(`${moduleList.orderInfo}/getWaybillsByReverse`, {
      params,
    });
  },
  // 运单信息
  reqWaybillInfo(params) {
    return fetch.get(
      `${moduleList.thirdService}/waybill/commonWaybillListByWaybillNos`,
      { params }
    );
  },
  // 仲裁列表
  getArbitrationList(code) {
    return fetchPub.get(
      `${moduleList.arbitration}/queryResults?waybillNo=` + code
    );
  },
  // 问题件列表
  getProblemPieceList(code) {
    return fetchPub.get(
      `${moduleList.problemPiece}/detailWithServiceRecordCount?waybillNo=` +
      code
    );
  },
  // 问题件回复记录列表
  getproblemServiceRecordList(id) {
    return fetch.get(
      `${moduleList.problemServiceRecord}/list?problemPieceId=` + id
    );
  },
  // 工单/理赔
  getWorkOrderList(code) {
    return fetchPub.post(
      `${moduleList.workOrder}/getProblemRecords?waybillNo=` + code
    );
  },
  // 质量
  getQualityList(code) {
    return fetchPub.get(
      `${moduleList.problemExpressWo}/listByWaybillNo?waybillNo=${code}`
    );
  },
  // 物流跟踪
  traceDataList(waybillNo, isAllPod) {
    return fetch.get(
      `${moduleList.thirdService}/ops/podTrackingList?isAllPod=${isAllPod ? 1 : 2
      }&waybillNos=${waybillNo}`
    );
  },
  // 内往官网轨迹
  getTrailListWorkOrder(params) {
    return fetch.post(`${moduleList.thirdService}/ops/tracking`, params)
  },
  // 物流网点信息
  queryByNetworkIds({ networkIds, waybillNo }) {
    return fetch.get(
      `${moduleList.networkAbnormalInformation}/queryByNetworkIds?networkIds=${networkIds}&waybillNo=${waybillNo}`
    );
  },
  // 任务编号查询异常信息
  queryException: (shipmentNo) =>
    fetch.get(
      `${moduleList.thirdService}/ops/shipment/queryException?shipmentNo=${shipmentNo}`
    ),
  // 根据任务编号查询经停点列表
  getStopList: (shipmentNo) =>
    fetch.get(
      `${moduleList.thirdService}/ops/shipment/getStopList?shipmentNo=${shipmentNo}`
    ),
  // 查询包牌信息
  getPackInfo: (packageNumber) =>
    fetch.get(
      `${moduleList.thirdService}/ops/waybillIdsByPackageNumber?packageNumber=${packageNumber}`
    ),
  // 图片地址转换接口
  reqReviewImage(reqData) {
    return fetch.post(`${moduleList.podTracking}/img/path`, reqData);
  },
  // 查网点联系信息
  reqNetworkInfo(params) {
    return fetch.get(
      `${moduleList.thirdService}/lmdm/getNetworkForTrace`,
      { params }
    );
  },
  // 查询来电记录
  getCallRecord(reqData) {
    return fetchPub.post(`${moduleList.workOrder}/queryCallRecord`, reqData)
  },
  // 百世请求物流轨迹
  getQueryBs(reqData) {
    return fetch.post(`${moduleList.bS}/queryBillTrace`, reqData)
  },
  // 百世基础信息
  queryBillBs(reqData) {
    return fetch.post(`${moduleList.bS}/queryBillDecryption`, reqData)
  },
  queryBillSensitive(reqData) {
    return fetch.post(`${moduleList.bS}/queryBillSensitive?billCode=${reqData.billCode}`)
  },
  getPhoneNumber(reqData) {
    return fetch.post(`${moduleList.workOrder}/queryMobilePhone`, reqData)
  },
  // 短信手机号脱敏
  queryMsgMobilePhone(reqData) {
    return fetch.post(`${moduleList.workOrder}/queryMsgMobilePhone`, reqData)
  },
  // 邮政工单
  getPostalInfo(params) {
    return fetch.post(`${moduleList.postal}/getPostalInfo`, params)
  },
  // 根据订单查询基础信息
  getOmsOrderById(reqData) {
    return fetch.get(`${moduleList.thirdService}/getOmsOrderById?orderId=${reqData}`)
  },
  // 短信记录
  queryMsgRecord(reqData) {
    return fetchPub.post(`${moduleList.workOrder}/queryMsgRecord`, reqData)
  },
  // 基础信息--订单标签
  getOrderLabelList(reqData) {
    return fetch.get(`${moduleList.thirdService}/getOrderLabelList?waybillNo=${reqData}`)
  },
  // 查询关联三段运单接口
  getWaybillRelation(params) {
    return fetch.get(`${moduleList.thirdService}/getWaybillRelationByType`, { params })
  },
  // 基础信息--虚拟号
  privateNumberQuery(params) {
    return fetch.get(`${moduleList.orderInfo}/privateNumberQuery`, { params })
  },
   // 查询异常信息
  getWaringData(reqData) {
    return fetchPub.post(`${APICUS}/networkAbnormalWaybill/queryExceptionByWaybillOrPhone`, reqData)
  },
  // 详情工单处理记录列表
  reqTaskOperateRecord(params) {
    return fetch.post(`${GATEWAYSER.SQSQT}/taskOperateRecord/page`, params)
  },
  // 详情工单处理记录列表
  reqTaskOperateRecordNew(params) {
    return fetch.get(`${GATEWAYSER.SQSQT}/taskOperateRecord/listByTaskId`, { params })
  },
  // 获取图片地址
  getImageList(params) {
    return fetch.post(`${APICUS}/imagesQuery/img/url`, params)
  },
  getPickupcode(reqData) {
    return fetchPub.post(`/bpo/receiveCode/queryRecordByBillCode`, reqData)
  },
   // 取件信息查询
  getPickupReservation(params) {
    return fetch.post(`${GATEWAY.SER}/workOrderInfo/getPickupReservation`, params)
  },
  // 取消取件预约
  cancelPickupReservation(params) {
    return fetch.post(`${GATEWAY.SER}/workOrderInfo/cancelPickupReservation`, params)
  }

};

/**
 * 任务中心-old
 */
export const serviceQualityTaskCenter = {
  // 获取分页列表
  reqList: (params) =>
    fetch.get(`${moduleList.exportTask}/pageBalance`, { params }),
  getFileUrl: (params) =>
    fetch.get(
      `${moduleList.exportTask}/fileUrl`,
      { params },
      { handle: true }
    ),
};

/**
 * 任务中心-new
 */
export const serviceQualityTaskCenterNew = {
  // 获取分页列表
  reqList: (params) =>
    fetch.get(`${moduleList.exportTask}/pageBalance`, { params }),
  getFileUrl(params) {
    const gatewayType =
      params.gatewayType === 1 ? GATEWAYSER.CSSPDD : APICUS;
    const url = `${gatewayType}/${params.moduleName}/export/fileUrl?fileName=${params.fileName}&fileUrl=${params.fileUrl}`;

    // 特殊指定url // 临时解决 仲裁流水下载 url 未统一 /export/fileUrl 结尾
    let specialUrl = "";
    if (
      typeof params.gatewayType === "string" &&
      params.gatewayType.match(/^\/\w+\//)
    ) {
      specialUrl = `${params.gatewayType}?fileName=${params.fileName}&fileUrl=${params.fileUrl}`;
    }

    return fetch.get(specialUrl || url, { handle: true });
  },
};

/**
 * 下载中心
 */
export const qtServiceCenterNew = {
  // 获取分页列表
  reqList: params => fetch.get(`${moduleList.exportTask}/pageBalance`, { params }),
  getFileUrl(params) {
    const url = `${params.gatewayType}?fileName=${params.fileName}&fileUrl=${params.fileUrl}`
    return fetch.get(url, { handle: true })
  }
}

/**
 * 工单发送短信
 */

export const workOrderSms = {
  reqList: (reqData) =>
    fetch.post(
      `${moduleList.messageTemplate}/getSendTemplate`,
      reqData
    ),
  sendSms: (reqData) =>
    fetch.post(`${moduleList.messageTemplate}/sendMsg`, reqData),
};


/**
 * 任务中心
 */

export const taskCenter = {
  reqList(params) {
    return fetch.get((params.gatewayType ? `${moduleList[params.gatewayType]}` : `${moduleList.taskExport}`) + '/pageBalance', { params })
  },
  getFileUrl: params => fetch.get((params.gatewayType ? `${moduleList[params.gatewayType]}` : `${moduleList.taskExport}`) + '/fileUrl', { params }, { handle: true })
}

// mixin接口获取
export const publicApi = {
  // 获取账号信息
  reportUserLevel: params => fetch.get(`${moduleList.ylwebsqsserviceonline}/systemPublicInformation/reportUserLevel`, { params }),
  // 客服信息分页查询
  reqCustomers: params => fetch.get(`${moduleList.ylwebsqsserviceonline}/systemPublicInformation/customers`, params),
  // 技能组信息查询
  getUserSkillGroup: params => fetch.get(`${moduleList.ylwebsqsserviceonline}/systemPublicInformation/getUserSkillGroup`, { params }),
  // 渠道信息查询
  getChannelInfo: params => fetch.get(`${moduleList.ylwebsqsserviceonline}/systemPublicInformation/getChannelInfo`, { params }),
  // 预览
  reqDetail: ({ id }) => fetch.get(`${GATEWAYSER.SQS_CUSTOMER}/publicityPictureConfig/getConfigDetail?id=${id}`)
}
/**
 * 退转件
 */
export const BackTransferApi = {
  reqCustomerType(params) {
    return fetch.post(`/sqscustomersupportweb/opsIntercept/customerType`, params)
  },
  reqReback(params) {
    return fetch.post(`/sqscustomersupportweb/opsIntercept/reback`, params)
  },
  reqAddress(address) {
    return fetch.get(`/sqscustomersupportweb/opsIntercept/ocr/address?address=${address}`)
  },
  reqBatchQueryRegister(params) {
    return fetch.post(`/sqscustomersupportweb/opsIntercept/batchQueryRegister`, params)
  },
  reqTransfer(params) {
    return fetch.post(`/sqscustomersupportweb/opsIntercept/transfer`, params)
  },
  reqSysArea(params) {
    return fetch.get(`${moduleList.sysArea}/select`, {
      params,
    });
  },
}
/**
 * 任务中心-new
 */
export const exportDialogApi = {
  // 获取分页列表
  reqList: params => fetch.post(`/sqsimportexportapi/web/exportTask/pageSelf`, params),
  getFileUrl(params) {
    return fetch.get(`/sqsimportexportapi/web/exportTask/downloadFile?taskId=${params.id}`, { handle: true })
  }
}
